/* Grace Letters – Shopify-Theme (Version 2) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var fmtTpl = (window.GL && GL.moneyFormat) || '{{amount_with_comma_separator}} €';
  var money = function (cents) { var a = (cents / 100).toFixed(2); return fmtTpl.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a.replace('.', ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100))).replace(/\{\{\s*amount\s*\}\}/, a).replace(/<[^>]*>/g, ''); };

  /* Menü */
  var burger = $('.burger'), mnav = $('#mobile-nav');
  if (burger && mnav) burger.addEventListener('click', function () {
    var open = mnav.classList.toggle('is-open'); burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    $$('.cartlink').forEach(function (el) { el.setAttribute('aria-label', 'Warenkorb, ' + n + ' Artikel'); });
  }

  /* Produkt */
  var section = $('[data-product-section]');
  if (section) {
    var pj = JSON.parse(($('[data-product-json]') || {}).textContent || '{}');
    var form = document.getElementById('product-form');
    var variantInput = $('[data-variant-input]', section);
    var planInput = $('[data-plan-input]', section);
    var priceOut = $('[data-price-out]', section);
    var qty = $('[data-qty]', section);
    var addBtn = $('[data-add]', section);
    var mainImg = $('.product__main img', section);

    $$('.thumb', section).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.thumb', section).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        if (mainImg) { mainImg.removeAttribute('sizes'); mainImg.srcset = t.getAttribute('data-srcset'); mainImg.src = t.getAttribute('data-src'); mainImg.alt = t.getAttribute('data-alt'); mainImg.setAttribute('sizes', '(max-width: 1100px) 100vw, 58vw'); }
      });
    });

    function variant() { var id = parseInt(variantInput.value, 10); return (pj.variants || []).filter(function (v) { return v.id === id; })[0]; }
    function refresh() {
      var v = variant(); if (!v) return;
      var price = v.price;
      var planId = planInput ? parseInt(planInput.value, 10) : NaN;
      if (planId && v.selling_plan_allocations) {
        var a = v.selling_plan_allocations.filter(function (x) { return x.selling_plan_id === planId; })[0];
        if (a) price = a.price;
      }
      var q = Math.max(1, parseInt(qty.value, 10) || 1);
      priceOut.textContent = money(price * q);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
    }
    function group(sel, onPick) {
      $$(sel, section).forEach(function (b) {
        b.addEventListener('click', function () {
          $$(sel, section).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true'); onPick(b); refresh();
        });
      });
    }
    group('[data-variant]', function (b) {
      variantInput.value = b.getAttribute('data-variant');
      var url = new URL(window.location.href); url.searchParams.set('variant', variantInput.value);
      window.history.replaceState({}, '', url.toString());
    });
    group('[data-plan]', function (b) { if (planInput) { planInput.value = b.getAttribute('data-plan'); planInput.disabled = !planInput.value; } });
    group('[data-who]', function (b) {
      var gift = b.getAttribute('data-who') === 'gift';
      var box = $('[data-gift-box]', section); if (!box) return;
      box.hidden = !gift;
      $$('textarea, [data-gift-flag]', box).forEach(function (el) { el.disabled = !gift; });
    });
    $('[data-dec]', section).addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); refresh(); });
    $('[data-inc]', section).addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; refresh(); });
    qty.addEventListener('change', refresh);

    if (form && window.fetch) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var toast = $('[data-toast]', section);
      addBtn.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          setCount(cart.item_count);
          toast.innerHTML = 'Im Warenkorb. <a href="' + ((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart') + '">Zum Warenkorb</a>';
          toast.classList.add('is-on');
        })
        .catch(function (err) {
          toast.textContent = (err && (err.description || err.message)) || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.';
          toast.classList.add('is-on');
        })
        .then(function () { refresh(); });
    });
    refresh();
  }

  /* Tabs */
  $$('[role="tablist"]').forEach(function (list) {
    var tabs = $$('[role="tab"]', list);
    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
        if (on && focus) t.focus();
      });
    }
    tabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () { select(idx); });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); select((idx + 1) % tabs.length, true); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); select((idx - 1 + tabs.length) % tabs.length, true); }
      });
    });
  });

  /* Briefe-Filter */
  var picker = $('[data-picker]');
  if (picker) $$('.pill', picker).forEach(function (b) {
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-pressed') !== 'true';
      $$('.pill', picker).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      if (on) b.setAttribute('aria-pressed', 'true');
      var target = on ? b.getAttribute('data-target') : null;
      $$('[data-letter]').forEach(function (c) {
        c.classList.toggle('is-dim', !!target && c.getAttribute('data-letter') !== target);
        c.classList.toggle('is-hit', !!target && c.getAttribute('data-letter') === target);
      });
    });
  });

  /* FAQ */
  var faq = $('[data-faq]');
  if (faq) {
    var cat = 'all', q = '';
    var items = $$('.faq-item', faq), none = $('.faq__none', faq);
    var apply = function () {
      var shown = 0;
      items.forEach(function (it) {
        var ok = (cat === 'all' || it.getAttribute('data-cat') === cat) && (!q || it.textContent.toLowerCase().indexOf(q) !== -1);
        it.hidden = !ok; if (ok) shown++;
      });
      if (none) none.style.display = shown ? 'none' : 'block';
    };
    $$('[data-cat-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-cat-btn]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true'); cat = b.getAttribute('data-cat-btn'); apply();
      });
    });
    var s = $('#faq-q'); if (s) s.addEventListener('input', function () { q = s.value.trim().toLowerCase(); apply(); });
  }

  /* Warenkorb: +/- sendet das Formular */
  var cf = $('[data-cart-form]');
  if (cf) {
    $$('.cartrow', cf).forEach(function (row) {
      var input = $('input[name="updates[]"]', row);
      var go = function (d) { input.value = Math.max(0, (parseInt(input.value, 10) || 0) + d); cf.submit(); };
      var dec = $('[data-cart-dec]', row), inc = $('[data-cart-inc]', row);
      if (dec) dec.addEventListener('click', function () { go(-1); });
      if (inc) inc.addEventListener('click', function () { go(1); });
      input.addEventListener('change', function () { cf.submit(); });
    });
  }
})();
